<template>
  <div class="card ripple col-sm-6 col-md-4 col-lg-3" @click="$emit('click')" :class="{ 'table-locked': tab.inUse }">
    <div class="title-box">
      <h5>{{ tab.Name }}</h5>
      <font-awesome-icon v-if="tab.inUse" icon="lock" class="lock-icon" />
    </div>
    <div class="tab-body">
      <h6>Cashier : {{ tab.user }}</h6>
      <h6>Items : {{ tab.items.length }}</h6>
      <span class="badge bg-info text-sm" v-if="tip > 0">Tip : {{ $utils.formatMoney(tip) }}</span>
      <h6>Total : {{ $utils.formatMoney(getSaleTotal(tab.items) + tip) }}</h6>
    </div>
  </div>
</template>

<script>
import {Storage} from "@/services/Storage";
import store from "@/store";

export default {
  name: "SingleTable",
  beforeMount() {
    this.getTipTotal();
  },
  props: {
    tab: {type: Object, required: true}
  },
  data() {
    return {
      tip: 0
    }
  },
  methods: {
    getSaleTotal(array) {
      let total = 0;
      for (let i = 0; i < array.length; i++) {
        total += array[i].Line;
        let instructions = array[i].instructions;
        if (instructions) {
          for (let k = 0; k < instructions.length; k++) {
            let price = instructions[k].Price;
            total += price;
          }
        }
      }
      return total;
    },
    async getTipTotal() {
      let saleTotal = this.getSaleTotal(this.tab.items);
      let settings = await Storage.getDeviceSettings();
      let tip = 0;
      if (settings && settings.AutoTip > 0) {
        tip = Number(settings.AutoTip);
        tip = (tip / 100) * saleTotal;
      }
      this.tip = tip;
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 380px) {
  .card {
    width: 159px !important;
  }
}

.card {
  height: 150px;
  width: 170px;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 1px 3px 9px lightgrey;
  display: flex;
  max-width: 180px;
  overflow: hidden;
  flex-direction: column;
  justify-content: space-between;
  transition: all 200ms;
  position: relative;
  cursor: pointer;

  &.table-locked {
    background-color: #ebe9e9e3;

    
    .lock-icon {
      color: #dc3545;
      margin-left: 8px;
    }
  }

  .title-box {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #d1d2d4;
    align-items: center;

    h5 {
      font-weight: 700;
      text-transform: uppercase;
      color: #2e2e2e;
    }
  }

  &:focus, &:hover {
    transform: scale(1.05);
  }
}

h5 {
  font-size: 1.02rem;
  margin-top: 10px;
  word-wrap: anywhere;
}

h6 {
  font-size: 0.9rem;
  font-weight: bolder;
}

#title {
  font-size: 1rem;
  align-content: center;
}
</style>
